<div [innerHTML]="pdfInnerHtml" style="height: 76vh"></div>
